import React from 'react';
import '../commonComponents/commonComponents.css';

const SubmitButton = ({
    isLoading = false,
    text = "Submit",
    onClick,
    disabled = false,
    className = "",
    icon = null,
    loader = null,
    ...rest
}) => {
    return (
        <button
            onClick={onClick}
            disabled={isLoading || disabled}
            className={`TravelSubmit-BTN ${className} ${isLoading ? "disabled opacity-70" : ""}`}
            {...rest}
        >
            {isLoading ? (
                <>
                    {loader || <DefaultLoader />}
                    Wait...
                </>
            ) : (
                <>
                    {icon && <span className="mr-2">{icon}</span>}
                    {text}
                </>
            )}
        </button>
    );
};

// Default spinner if no loader passed
const DefaultLoader = () => (
    <span className="submitBtnLoader"></span>   
);

export default SubmitButton;
